module.exports = __webpack_public_path__ + "img/nika04-b88308152z.120150121203156000gnh7dqq5.10.c78d519f.webp";